import { Outlet } from "react-router-dom";

import { DashboardLayout as Layout } from "@src/deprecated/pages/DashboardLayout";
import { useAppSSEEvents } from "@src/features/sse";
import { useActor } from "@src/shared/providers/actorProvider";

export function meta() {
  return [
    { title: "Dashboard" },
    { name: "description", content: "Dashboard" },
  ];
}

export async function clientLoader() {
  return {};
}

export default function DashboardLayout() {
  const actor = useActor();
  const userId = actor.user.id;

  useAppSSEEvents(userId, actor.type, {
    enabled: userId != null,
  });

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
